import React from "react";
import layers from "../img/layers.png";
import react from "../img/react.png";
import material_UI from "../img/material_UI.png";
import javascript from "../img/javascript.png";

import visual_studio from "../img/visual-studio.png";
import mongodb from "../img/mongodb.png";
import adob from "../img/adob.png";
import symfony from "../img/symfony.png";
import {Paper,Grid,makeStyles} from '@material-ui/core';


import PropTypes from "prop-types";



import MessengerCustomerChat from 'react-messenger-customer-chat';

//import styles from "assets/jss/material-kit-react/views/profilePage.js";




const useStyles = makeStyles((theme) => ({

	root: {
	  maxWidth: 345,
	  
	},
	image: {
		width: 50,
		height: 50,
	},
	paper: {
		width: 50,
		height: 50,
		padding: theme.spacing(2),
		textAlign: 'center',
		color: theme.palette.text.secondary,
	  },
	cover: {
		width: 151,
	  },
	large: {
		width: theme.spacing(7),
		height: theme.spacing(7),
	  },
	  

	}));
	


							

export default class About extends React.Component {
	render() {
	//	const classes = useStyles();
		return (

			
			<div id="about-container"	className="content-containers container text-center mt-5">
      
				
         
           
         
	  
			


				

	<br/>
	<br/>
				<h1 id="about" className={this.props.bounceLeft}>SKILLS &  TOOLS</h1>

				<Grid container spacing={3}>
			  	    <Grid item xs className={this.props.fadeInLeft}>
                         <Paper className={useStyles.paper}><img  src={layers} alt=""/></Paper>
                    </Grid>

				    <Grid item xs className={this.props.fadeInLeft}>
                        <Paper className={useStyles.paper}><img src={material_UI} alt=""/></Paper>
                    </Grid>

                    <Grid item xs className={this.props.fadeInLeft}>
                        <Paper className={useStyles.paper} ><img src={react} alt=""/></Paper>
                    </Grid>

			       <Grid item xs className={this.props.fadeInLeft}>
                       <Paper className={useStyles.paper} ><img src={javascript} alt=""/></Paper>
                   </Grid>
                </Grid>


				<Grid container spacing={3}>
				    <Grid item xs className={this.props.fadeInRight}>
                        <Paper className={useStyles.paper}><img src={visual_studio} alt=""/></Paper>
                    </Grid>

			     	<Grid item xs className={this.props.fadeInRight}>
                       <Paper className={useStyles.paper}><img src={mongodb} alt=""/></Paper>
                    </ Grid>

                   <Grid item xs className={this.props.fadeInRight}>
                       <Paper className={useStyles.paper} ><img src={adob} alt=""/></Paper>
                   </Grid>

			       <Grid item xs className={this.props.fadeInRight}>
                       <Paper className={useStyles.paper} ><img src={symfony} alt=""/></Paper>
                   </Grid>
                </Grid>
					
				
					
				
				
					
									

				

				
				
			
			
				<div>
   <MessengerCustomerChat
		pageId="103040064736222" 
		appID ="2669160163211521"
	  />
			</div>
			
			
			</div>
			
		);
	}
}

About.propTypes = {
	bounceLeft: PropTypes.string,
	fadeInLeft: PropTypes.string,
	fadeInRight: PropTypes.string,
	fadeIn: PropTypes.string,
	tada: PropTypes.string
};
